export interface TimesheetEntryLike {
  hours?: number | string | null;
  startTime?: string | null;
  stopTime?: string | null;
  organizationId?: string | null;
}

export function calculateEntryHours(entry: TimesheetEntryLike): number {
  if (entry.hours != null && entry.hours !== '') {
    const h = Number(entry.hours);
    return Number.isFinite(h) ? h : 0;
  }
  if (entry.startTime && entry.stopTime) {
    const start = new Date(entry.startTime).getTime();
    const stop = new Date(entry.stopTime).getTime();
    if (stop > start) {
      return (stop - start) / (1000 * 60 * 60);
    }
  }
  return 0;
}

export function sumWorkedHours(entries: TimesheetEntryLike[]): number {
  return entries.reduce((total, entry) => total + calculateEntryHours(entry), 0);
}

export function filterEntriesByOrganization(
  entries: TimesheetEntryLike[],
  organizationId: string
): TimesheetEntryLike[] {
  return entries.filter((entry) => entry.organizationId === organizationId);
}

export function groupWorkedHoursByOrganization(
  entries: TimesheetEntryLike[]
): Map<string, number> {
  const map = new Map<string, number>();
  for (const entry of entries) {
    const orgId = entry.organizationId || '_unknown';
    map.set(orgId, (map.get(orgId) || 0) + calculateEntryHours(entry));
  }
  return map;
}
